
const keyTest = /^\d+$/;
export default function writeNestedProperty(model: any, path: string, value: any): void {
	if (!path) return;

	const tokens = path.split(".");
	const propName = tokens.pop();
	if (!propName) return;

	const target = tokens.reduce((obj, key) => {
		if (!(key in obj)) {
			obj[key] = keyTest.test(key) ? [] : {};
		}
		return obj[key];
	}, model);

	target[propName] = value;
}
